
export const ERRORS = {
  auth__password__short: 'Passordet er for kort',
  auth__email__taken: 'Epostadressen finnes allerede i systemet. Vil du logge inn i stedet?'
}

